import { useTranslation } from "react-i18next"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useEmployerLogged } from "../../context/useEmployeeContext"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { Employee } from "../../Objects/Employee/Employee"
import { companyMemory } from "../../Objects/Memory/Memory"
import { PostRequest } from "../../services/ApiClientService"
import type { CompleteOwnerProfileDto } from "./useCreateOwnerProfile"

export const useSaveOwnerProfile = () => {
  const { t } = useTranslation("general")
  
  const { userEmployee, setEmployee } = useEmployerLogged()
  
  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleSaveOwnerProfile = async (profile: CompleteOwnerProfileDto) => {
    if (!userEmployee) return

    try {
      enableLoad()

      const response = await PostRequest<boolean>(API_ROUTES.ACCOUNT.COMPLETE_OWNER_PROFILE, profile)

      if (!response.success) throw new Error(response.message)

      const updatedEmployee = new Employee(userEmployee)

      updatedEmployee.personEntity.name = profile.name

      updatedEmployee.personEntity.phone = profile.phoneNumber

      setEmployee(updatedEmployee)

      if (profile.companyName) companyMemory.companyName = profile.companyName
    } catch (error: unknown) {
      const message = error instanceof Error ? error.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return { handleSaveOwnerProfile }
}
